import API_ENDPOINTS from "../config/apiEndpoints";
import { downloadBlob, ensureOk, requestWithAuth } from "./apiClient";

const downloadPdf = async (endpoint, fileName, errorMessage) => {
  try {
    const response = await requestWithAuth(endpoint, { method: "GET" });
    ensureOk(response, errorMessage);
    await downloadBlob(response, fileName);
  } catch (error) {
    console.error("Error al descargar el archivo PDF:", error);
    throw error;
  }
};

export const apiexportacionService = {
  getFichajesByDate: async (empresa, desde, hasta, departamentoId) => {
    let params = `?desde=${desde}&hasta=${hasta}`;
    if (departamentoId !== null && departamentoId !== "") {
      params = `${params}&departamento=${departamentoId}`;
    }

    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.INFORME_FICHAJES(empresa, params),
      `informe_fichajes_simplificado_${desde}_${hasta}.pdf`,
      "Error al descargar el archivo PDF de empleados"
    );
  },

  getFichajesDetallados: async (
    empresa,
    desde,
    hasta,
    departamentoId,
    hasFirma
  ) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.FICHAJES_DETALLADOS(
        empresa,
        desde,
        hasta,
        departamentoId,
        hasFirma
      ),
      `informe_detallado_${desde}_${hasta}.pdf`,
      "Error al descargar el archivo PDF de empleados"
    );
  },
  getInformeFichajesCompleto: async (empresa, desde, hasta, departamentoId) => {
    let params = `?desde=${desde}&hasta=${hasta}`;
    if (departamentoId !== null && departamentoId !== "" && departamentoId !== "Todos") {
      params = `${params}&departamento=${departamentoId}`;
    }

    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.INFORME_FICHAJES_COMPLETO(empresa, params),
      `informe_fichajes_completo_${desde}_${hasta}.pdf`,
      "Error al descargar el informe completo de fichajes"
    );
  },
  getInformeTrazabilidadFichajes: async (empresa, desde, hasta, empleadoId, estado) => {
    let params = `?desde=${desde}&hasta=${hasta}`;
    if (empleadoId !== null && empleadoId !== undefined && empleadoId !== "") {
      params = `${params}&empleado=${empleadoId}`;
    }
    if (estado !== null && estado !== undefined && estado !== "") {
      params = `${params}&estado=${estado}`;
    }

    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.INFORME_TRAZABILIDAD_FICHAJES(empresa, params),
      `informe_trazabilidad_fichajes_${desde}_${hasta}.pdf`,
      "Error al descargar el informe de trazabilidad de fichajes"
    );
  },

  getFichaEmpleado: async (empresa, empleadoId, anno) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.FICHA_EMPLEADO(empresa, empleadoId, anno),
      `ficha_empleado_${empleadoId}.pdf`,
      "Error al descargar el archivo PDF de empleados"
    );
  },

  getFichaHorario: async (empresa, empleadoId, anno) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.FICHA_HORARIO(empresa, empleadoId, anno),
      `ficha_horario_empleado_${empleadoId}.pdf`,
      "Error al descargar el archivo PDF de horario"
    );
  },

  getFichaCalendario: async (empresa, empleadoId, anno) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.FICHA_CALENDARIO(empresa, empleadoId, anno),
      `ficha_calendario_${empleadoId}.pdf`,
      "Error al descargar el archivo PDF de calendario"
    );
  },

  getHorasExtra: async (empresa, departamentoId, anno) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.HORAS_EXTRA(empresa, departamentoId, anno),
      `informe_horas_${anno}.pdf`,
      "Error al descargar el archivo PDF de empleados"
    );
  },
  getHorasExtraMes: async (empresa, anno, mes, departamentoId, centroId) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.HORAS_EXTRA_MES(empresa, anno, mes, departamentoId, centroId),
      `informe_horas_extra_mes_${anno}${mes ? "_" + mes : ""}.pdf`,
      "Error al descargar el informe de horas extra por mes"
    );
  },

  getLopd: async (empresa, empleadoId) => {
    await downloadPdf(
      API_ENDPOINTS.EXPORTACION.LOPD(empresa, empleadoId),
      `acuerdo_confidencialidad_${empleadoId}.pdf`,
      "Error al descargar el archivo PDF"
    );
  },
};
